import { Avatar, Progress, Typography, Tooltip, Dropdown, Menu, Modal, Input } from 'antd'
import React, { useState, useEffect, useRef } from 'react'
import { LinkOutlined, LoadingOutlined, PlusCircleOutlined, UserOutlined } from '@ant-design/icons'
import { MdCastConnected, MdMoreVert } from 'react-icons/md'
import { Api, Color, Notification } from 'services'
import moment from 'moment'
import { connect } from 'react-redux'
import { SquareSubIcon } from 'components/subIcon'
import { IoMdChatbubbles, IoMdVideocam } from 'react-icons/io'
import { RiWirelessChargingLine } from 'react-icons/ri'
import { postEmbedLink, setStreamId } from 'actions/broadcast'
import { fetchStudentListData, joinClass, setBroadcastSelectedClassroom, setCardData, setJoinLoader, setLiveStreamUrl, setSelectedId } from 'actions/schedule'
import { useHistory } from 'react-router-dom'
import { FaGraduationCap } from 'react-icons/fa'
import { handleJoinClass } from './handleJoinClass'
import Conference from "Assets/schedule/confrence.svg"
import Online from "Assets/schedule/online.svg"
import Offline from "Assets/schedule/offline.svg"
import OtherColor from "Assets/schedule/other_color.svg"
import YTPlayer from 'components/ytPlayer'
import { EventRegister } from 'react-native-event-listeners'
import UserAvatar from 'components/userAvatar'
import AnimatedTextField from 'components/AnimatedTextField'
import { Button } from 'components/Button'
import ScheduleDetailsDrawer from './ScheduleDetailsDrawer';
import { getSchedulePermissions, canManageClassLink } from './schedulePermissions';
const { Text } = Typography
// new
const checkCirlce = require("../../Assets/scheduleAttendance/CheckCircle(1).svg").default
const menuMore = require("../../Assets/ic-more.svg").default
const avattar = require("../../Assets/Group 11416.svg").default
export const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
export const regExpLive = /^https:\/\/(www\.)?youtube\.com\/live\/[a-zA-Z0-9_-]+(\?.*)?$/;
export const regexMeet = /^https:\/\/meet\.google\.com\/([a-z]{3}-[a-z]{4}-[a-z]{3}(-[a-z])?|lookup\/[a-z0-9-]+)(\?authuser=\d+)?$/;
export const regexstudio = /^https:\/\/(www\.)?studio\.youtube\.com\/video\/[a-zA-Z0-9_-]+\/livestreaming(\?.*)?$/;
// const regexyt = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|live\/|v\/)?)([\w\-]+)(\S+)?$/;
export const EmbedModal = ({ visible = false, onClose = () => { }, onOk = () => { }, embedding = false, adding = true }) => {
  const [link, setlink] = useState(null);
  const [matching, setMatch] = useState(false);
  const linkedchanged = (e) => {
    let text = e.target.value
    const isPlaylist = /[?&]list=/i.test(text)
    if (text.match(regExpLive)) {
      let videoId = text?.split('?')?.[0]?.split('/')?.[4]
      text = `https://www.youtube.com/watch?v=${videoId}`
    } else if (text.match(regexstudio)) {
      let videoId = text?.split('?')?.[0]?.split('/')?.[4]
      text = `https://www.youtube.com/watch?v=${videoId}`
    }
    setlink(text)
    if (text.match(regExp)) {
      let match = text.match(regExp)
      setMatch(match[2].length == 11 && !isPlaylist)
    } else if (text.match(regexMeet)) {
      setMatch(false)
    } else {
      setMatch(false)
    }

  }

  const isValid = !link || link === "" || (
    /^(https?:\/\/)?(www\.)?(youtu\.be\/|youtube\.com\/(watch\?v=|embed\/))([A-Za-z0-9_-]{11})(\?.*)?$/.test(link)
    && !(/[?&]list=/i.test(link))
  ) || /^(https?:\/\/)?(meet\.google\.com\/)[a-zA-Z0-9-]+$/.test(link);

  return (
    <Modal
      centered
      className='modal-round-corner'
      style={{ padding: 0 }}
      visible={visible}
      onCancel={onClose}
      onOk={onOk}
      closable={false}
      closeIcon={() => (<></>)}
      footer={null}
    >
      <div className='r-c-c' style={{ color: "black", fontSize: 18, fontWeight: "bold" }}>{adding ? 'Add link' : 'Replace link'}</div>
      <div className='r-c-c' style={{ color: "#636363", fontSize: 12, marginBottom: 20 }}>Please add the livestream link below</div>
      <div style={{ width: '100%' }}>
        <AnimatedTextField
          label="Livestream link"
          value={link}
          handleInputChange={linkedchanged}
          isMandatory={true}
          inputstyle={{ fontSize: 12, fontWeight: "normal", color: "black" }}
          inputId="link"
          isDisabled={false}
        />
        <p style={{ fontSize: '10px', font: 'normal normal normal 10px/26px Roboto', opacity: '1', color: '#AEAEAE', marginTop: 0 }}>Example: http://www.websitename.com/watch?v=2Qsg3rQcfIE</p>
        <div className='r-c-c' style={{ marginBottom: '1px', fontSize: '12px', color: '#FF414D', font: 'normal normal bold 12px/16px Roboto' }}>
          {
            isValid
              ? null
              : (<>Invalid link</>)
          }

        </div>
      </div>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {
          link && matching ?
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <YTPlayer keyboardControls={true} top={"calc(50% - 27px)"} isLive={true} videoUrl={link} />
            </div>
            : null
        }
      </div>
      <div className='r-c-c' style={{ marginTop: 15 }}>
        <Button style={{ width: "160px", marginRight: "45px", borderRadius: "8px" }} onClick={onClose}>CANCEL</Button>
        <Button
          type='primary'
          style={{ width: '160px', borderRadius: '8px' }}
          onClick={() => { onOk(link) }}
          disabled={!link || !isValid || embedding}
          loading={embedding}
        >
          {'SAVE'}
        </Button>
      </div>
    </Modal>
  )
}
const OngoingClassCard = ({
  onGoingItem, setStreamId, joinClass, setBroadcastSelectedClassroom, setJoinLoader, isJoinLoader, user, fetchStudentListData, setSelectedId,
  studentAttendanceData, presentStudents, setCardData, postEmbedLink, setLiveStreamUrl, togglePageLoader, pageLoader, currentDate
}) => {
  const menu = (
    <Menu style={{ width: "230px", background: "#FFFFFF", boxShadow: "8px 8px 18px #302A5F14", borderRadius: "8px" }}>
      <Menu.Item key="1" onClick={() => { handleJoin() }}>
        {onGoingItem.sUrl != undefined ? 'Replace link' : 'Add link'}
      </Menu.Item>
      {onGoingItem?.sUrl != undefined ?
        <Menu.Item key="2" onClick={() => { playStream() }}>
          Play stream
        </Menu.Item>
        : null}
    </Menu>

  );
  const history = useHistory();
  const playStream = () => {
    if (onGoingItem.sUrl.match(regexMeet)) {
      window.open(onGoingItem.sUrl, '_blank');
    } else {
      setLiveStreamUrl(onGoingItem.sUrl)
      history.push('/liveplayer')
    }
  }
  const [embedModalVisible, setEmbedModalVisible] = useState(false);
  const [embedding, setEmbedding] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  // Belt-and-suspenders guard for the Others-mode three-dots menu (Add/Replace link, Play
  // stream): its Menu.Item onClick already calls domEvent.stopPropagation(), but that Menu
  // is rendered by antd's Dropdown through a portal, and closing it mid-click can still let
  // the click "fall through" to the card underneath - opening the details drawer behind
  // whatever action was actually clicked. Any menu action stamps this ref right before running;
  // the card's own onClick ignores itself if it fires within that same instant.
  const lastMenuActionAtRef = useRef(0);
  const suppressCardClick = () => { lastMenuActionAtRef.current = Date.now(); };

  useEffect(() => {
    // When embed modal (Add/Replace link) closes, reset menu state
    if (!embedModalVisible) {
      setMenuOpen(false);
    }
  }, [embedModalVisible]);

  const [detailsOpen, setDetailsOpen] = useState(false);

  useEffect(() => {
    if (
      history.location.state?.scheduleId &&
      (history.location.state?.scheduleId === onGoingItem?.id || history.location.state?.scheduleId === onGoingItem?.scheduleId || history.location.state?.scheduleId === onGoingItem?.occurrenceId) &&
      (history.location.state?.activeTab === 'quizzes' || history.location.state?.activeTab === 'resources')
    ) {
      setDetailsOpen(true);
    }
  }, [history.location.state, onGoingItem.id]);
  const permissions = getSchedulePermissions(user);

  // Joining a live class: Admin, Planner, SuperAdmin OR the teacher whose class it is.
  // Deliberately NOT the same rule as editing - a teacher with no privilege still has to
  // be able to walk into their own classroom.
  const canJoinClass = user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('Admin') || user?.privilage?.includes('Planner') || (user?.role?.includes('Teacher') && onGoingItem?.teacher?.id === user?.id);

  // The class's own teacher can supply its livestream link whatever their privilege -
  // on an Others class that link is their meeting, and no one else can produce it.
  // Everyone else needs Creation rights. Was plain permissions.canCreate, which left a
  // bare Teacher with no way to add a link to their own class at all.
  const canEditClass = canManageClassLink(user, onGoingItem);

  // Opening the drawer is a third, separate thing. Every row of the matrix that can see
  // the Schedule module has at least one tab waiting behind this card (Attendance for
  // Operation + AttendanceMarker, Resources/Quizzes for a plain Data Operator), and
  // clicking is the only way to reach any of them, so "can view the module" is the whole
  // gate. Which tabs appear, and whether they are editable, is ScheduleDetailsDrawer's
  // call from the same matrix.
  const canOpenDetails = permissions.canViewModule;
  // Mark/Edit attendance has moved into the details drawer's Attendance tab, so the
  // card no longer carries a button of its own. Restore this to bring it back:
  // const showAttendanceActionOnCard = ['offline'].includes((onGoingItem?.mode || '').toLowerCase()) &&
  //   ((user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('Admin') || user?.privilage?.includes('Planner') || user?.privilage?.includes('AttendanceMarker')) ||
  //    (user?.role?.includes('Teacher') && onGoingItem?.teacher?.id === user?.id));
  const showAttendanceActionOnCard = false;

  const onPlay = () => { }
  const handleContact = () => {
    history.push("/care/chat")
  }

  const [isJoinNowLoading, setIsJoinNowLoading] = useState(false)

  const handleJoin = async () => {
    setCardData(onGoingItem);
    setIsJoinNowLoading(true);

    if (onGoingItem?.mode == "Broadcast") {
      let currentTime = new Date();
      if (onGoingItem.endTime) {
        // Parse end time
        const [hours, minutes, seconds] = onGoingItem.endTime.split(':').map(Number);
        let endDateTime = new Date();
        endDateTime.setHours(hours, minutes, 60, 0);

        // Calculate the difference in milliseconds
        let differenceInMilliseconds = endDateTime - currentTime;
        let differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);
        if (differenceInSeconds < 0) {
          Notification.error("Error", "Class end time has passed")
          setIsJoinNowLoading(false)
          return
        }
      }
      setStreamId(onGoingItem?.roomName != null ? onGoingItem.roomName : '1234')
      setBroadcastSelectedClassroom(onGoingItem)
      try {
        await joinClass(onGoingItem.id, () => {
          setIsJoinNowLoading(false)
        })
      } catch (error) {
        // join-class refused. Api has already put the reason on screen — most often that
        // this user is still recorded as present in the room by a visit that never left.
        // Stay on the schedule instead of opening a classroom that was never joined.
        setIsJoinNowLoading(false)
        return
      }
      history.push('/broadcast')
    }
    else if (onGoingItem?.mode == "Zoom 40") {
      await joinClass(onGoingItem.id, () => {
        setIsJoinNowLoading(false)
      })

      // history.push('/zoom')
      Notification.error("Error", "Zoom is not supported on web presently. Please join the class from the mobile.")
    } else if (onGoingItem?.mode == "Offline" || onGoingItem?.mode == "Conference") {
      setIsJoinNowLoading(false)
      Notification.error("Error", "This mode is not supported on web presently")
    } else if (onGoingItem?.mode === "Others" || onGoingItem?.mode === "Other") {
      setIsJoinNowLoading(false);
      setEmbedModalVisible(true);
    }
  }

  const markAttendanceHandler = () => {
    setSelectedId(onGoingItem?.id)
    setCardData(onGoingItem)
    fetchStudentListData(onGoingItem?.id)
    // TEMP DIAGNOSTIC — remove once the date-restore-on-back issue is confirmed fixed.
    console.log('[attendance-date-debug] markAttendanceHandler: currentDate prop =', currentDate, 'pathname =', `${history.location.pathname}${history.location.search}`);
    // Carry the selected date back with us so the Back button on
    // /schedule-attendance can return to it explicitly (same relay pattern
    // ScheduleDetailsDrawer.js's goToRecordingsPage uses for Play -> Back) -
    // scheduleAdmin.js otherwise has no way to tell this apart from a fresh
    // visit and resets the filter to today.
    history.push('/schedule-attendance', {
      from: {
        path: `${history.location.pathname}${history.location.search}`,
        state: {
          fromRecordingPlay: true,
          currentDate
        }
      }
    })

  }

  const onEmbed = async (link) => {
    setEmbedding(true);
    if (togglePageLoader) togglePageLoader(true)
    await postEmbedLink({ id: onGoingItem.id, sUrl: link })
    if (togglePageLoader) togglePageLoader(false)
    setEmbedding(false);
    setEmbedModalVisible(false);
    EventRegister.emit('apicall:scheduleHome');
  }

  const currentTime = moment().format("HH:mm:ss")
  let duration = moment.duration(moment(onGoingItem?.endTime, "HH:mm:ss").diff(moment(onGoingItem?.startTime, "HH:mm:ss")))
  let spendDuration = moment.duration(moment(currentTime, "HH:mm:ss").diff(moment(onGoingItem?.startTime, "HH:mm:ss")))
  let hours = duration.asHours()
  let spendHours = spendDuration.asHours()
  const isClassOver = onGoingItem?.endTime ? moment().isAfter(moment(`${moment().format('YYYY-MM-DD')} ${onGoingItem.endTime}`, 'YYYY-MM-DD HH:mm:ss')) : false;
  return (
    // <div className="ongoingclass-main" style={{position:"relative"}}>
    <div
      className="ongoingclass-main"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={(e) => {
        // The three-dots Dropdown/Menu and the EmbedModal both render through a portal -
        // stopPropagation() on their own onClick handlers was clearly not enough (still
        // reaching here somehow), so check what was actually clicked directly instead of
        // relying on propagation being stopped correctly upstream. e.target on a React
        // synthetic event always reflects the real originating DOM node even when that
        // node lives in a portal outside this card's own DOM subtree.
        // .ant-drawer is in the list for the same reason: the details drawer is
        // rendered inside this div too, so dismissing it by its mask would
        // otherwise bubble back here and immediately re-open it.
        if (e.target.closest && e.target.closest('.ant-dropdown, .ant-modal, .ant-modal-wrap, .ant-modal-mask, .ant-drawer')) {
          return;
        }
        if (Date.now() - lastMenuActionAtRef.current < 300) {
          return;
        }
        if (canOpenDetails) {
          setDetailsOpen(true);
        }
      }}
      style={{
        position: "relative",
        width: '100%',
        maxWidth: '330px',
        padding: "16px",
        overflow: "hidden",
        borderRadius: 16,
        background: "transparent",
        cursor: canOpenDetails ? 'pointer' : 'default',
        // border: "1px solid #AEAEAE", // Removed as per user request
      }}
    >
      <div
        style={{
          // Was position:absolute with hand-picked left/right values that had to
          // coincidentally match the card's own padding for this row to line up
          // with the subject icon below it - never quite exact. A normal in-flow
          // row shares that same padding automatically, guaranteeing the two
          // rows start at the same left edge instead of approximating it.
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text style={{ fontSize: 12, color: "#636363" }}>
          {moment(onGoingItem?.startTime, "HH:mm:ss").format("hh:mm A")} -{" "}
          {moment(onGoingItem?.endTime, "HH:mm:ss").format("hh:mm A")}
        </Text>

        {(onGoingItem.mode == "Zoom 40") ? (
          <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#E7F3FF', borderRadius: 16, padding: '4px 10px' }}>
            <IoMdVideocam style={{ color: '#1089FF' }} />
            <Text style={{ fontSize: 10, color: '#1089FF', marginLeft: 5 }}>Zoom 40</Text>
          </div>
        ) : (onGoingItem.mode == "Broadcast") ? (
          <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#E9FFF9', border: '1px solid #C8EEE4', borderRadius: 16, padding: '4px 10px' }}>
            <img src={Online} style={{ height: 14, width: 14 }} />
            <Text style={{ fontSize: 10, color: '#00A566', marginLeft: 5 }}>Online</Text>
          </div>
        ) : (onGoingItem.mode == "Conference") ? (
          <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#F6F4FE', borderRadius: 16, padding: '4px 10px' }}>
            <img src={Conference} style={{ height: 14, width: 14 }} />
            <Text style={{ fontSize: 10, color: '#594099', marginLeft: 5 }}>Conference</Text>
          </div>
        ) : ((onGoingItem.mode === "Others" || onGoingItem.mode === "Other") ? (
          <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            {/* Always show the Others pill */}
            <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#FFE5F4', borderRadius: 16, padding: '4px 10px' }}>
              <img src={OtherColor} style={{ height: 14, width: 14 }} />
              <Text style={{ fontSize: 10, color: '#E50087', marginLeft: 5 }}>Others</Text>
            </div>

            {/* three-dots Add/Replace link for Others.
                trigger was ['click', 'hover'] - the 'hover' part meant the menu could also
                close itself on mouse-leave a beat before a real click landed (any small drift
                mid-click), so the click fell through to the card underneath instead of hitting
                the menu item at all - opening the details drawer no matter what stopPropagation
                was added to the menu items themselves, since they never received the click.
                click-only removes that race. */}
            {(canEditClass) && (
              <div style={{
                position: 'relative',
                right: 0,
                opacity: 1,
                marginLeft: 8,
                transition: 'opacity 0.12s',
                pointerEvents: 'auto'
              }}>
                <Dropdown overlay={
                  <Menu style={{ borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                    <Menu.Item key="1" onClick={({ domEvent }) => { domEvent && domEvent.stopPropagation(); suppressCardClick(); setEmbedModalVisible(true); }}>{onGoingItem?.sUrl ? 'Replace link' : 'Add link'}</Menu.Item>
                    {onGoingItem?.sUrl ? <Menu.Item key="2" onClick={({ domEvent }) => { domEvent && domEvent.stopPropagation(); suppressCardClick(); if (onGoingItem.sUrl.match(regexMeet)) { window.open(onGoingItem.sUrl, '_blank'); } else { setLiveStreamUrl(onGoingItem.sUrl); history.push('/liveplayer') } }}>Play stream</Menu.Item> : null}
                  </Menu>
                } trigger={['click']} placement="bottomRight" onVisibleChange={(v) => { setMenuOpen(v); }}>
                  {/* stopPropagation lives here, on the div antd's Dropdown actually clones/
                      listens on for trigger={['click']} - NOT on the icon inside it. Stopping
                      it at the icon (one level deeper) would block the click from ever
                      reaching this div, so the Dropdown's own open logic never saw it either -
                      that's what silently broke click-to-open once 'hover' stopped masking it. */}
                  <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px' }} onClick={(e) => { e.stopPropagation(); suppressCardClick(); }}>
                    <MdMoreVert style={{ fontSize: 18, color: '#AEAEAE' }} />
                  </div>
                </Dropdown>
              </div>
            )}
          </div>
        ) : (onGoingItem.mode === 'Offline') ? (
          /* Offline badge only, no three-dots */
          <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#FFD8DA', border: '1px solid #FFF5F6', borderRadius: 16, padding: '4px 10px' }}>
              <img src={Offline} style={{ height: 14, width: 14 }} />
              <Text style={{ fontSize: 10, color: '#FF414D', marginLeft: 5 }}>Offline</Text>
            </div>
          </div>
        ) : null)}
      </div>

      <div
        style={{
          width: '100%',
          paddingBottom: 0,
        }}
      >

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            // paddingTop: 20 used to reserve room for the time/badge row above,
            // which was position:absolute and out of normal flow - now that it's
            // a normal in-flow row, it already takes up its own space, so this
            // just needs the visual gap between the two rows, not extra clearance.
            marginTop: 12,
          }}
        >
          <SquareSubIcon
            icon={onGoingItem?.subject?.icon || ""}
            name={onGoingItem?.subject?.name || ""}
            size={44}
          />

          <div style={{ display: "flex", flexDirection: "column", minWidth: 0, flex: 1 }}>
            <Text
              ellipsis={{ tooltip: onGoingItem?.subject?.name }}
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#1F1F1F",
                marginBottom: 6,
                display: 'block'
              }}
            >
              {onGoingItem?.subject?.name}
            </Text>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                fontSize: 13,
                color: "#636363",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
                <img
                  src={require("../../Assets/schedule/teacher.svg").default}
                  style={{ width: 14 }}
                />
                <Text
                  ellipsis={{ tooltip: onGoingItem?.teacher?.name }}
                  style={{ fontSize: 13, color: "#636363", maxWidth: 120, margin: 0 }}
                >
                  {onGoingItem?.teacher?.name}
                </Text>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <img
                  src={require("../../Assets/schedule/timer.svg").default}
                  style={{ width: 14 }}
                />
                <span>{Math.round(duration.asMinutes())} mins</span>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 12,
            // Modes that don't get a JOIN NOW/MARK ATTENDANCE button here (Others,
            // Conference, Zoom 40, Offline-without-privilege) render null on the right,
            // making this row shorter than it is on cards that do - which shrinks the
            // whole card and throws off the progress bar's bottom-edge "cut" below,
            // since that's positioned with fixed negative margins relative to this
            // content rather than anchored to the card itself. Reserve the same height
            // a button would take so every card (and thus the bar's cut) matches.
            minHeight: 32,
          }}
        >
          <div style={{ fontSize: 12, color: "#636363", flex: 1, minWidth: 0, overflow: 'hidden', marginRight: 16 }}>
            {onGoingItem?.standards && onGoingItem.standards.length > 0 ? (
              <Tooltip
                title={onGoingItem.standards.map(item => `${item.std}-${item.section}`).join(', ')}
                placement="bottom"
                getPopupContainer={(trigger) => trigger.parentElement}
              >
                <Text style={{ fontSize: 12, color: "#636363", display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                  {onGoingItem.standards.map(item => `${item.std}-${item.section}`).join(', ')}
                </Text>
              </Tooltip>
            ) : (
              <Tooltip
                title={onGoingItem?.batchName || ""}
                placement="bottom"
                getPopupContainer={(trigger) => trigger.parentElement}
              >
                <Text style={{ fontSize: 12, color: "#636363", display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                  {onGoingItem?.batchName || ""}
                </Text>
              </Tooltip>
            )}
          </div>


          {(onGoingItem?.mode || '').toLowerCase() === 'broadcast' ? (
            canJoinClass ? (
              <Button
                type="link"
                style={{
                  fontWeight: 600,
                  color: "#594099",
                  paddingRight: 0,
                  cursor: "pointer"
                }}
                onClick={(e) => { e.stopPropagation(); handleJoin(); }}
              >
                JOIN NOW
              </Button>
            ) : null

          ) : (
            // Mark Attendance used to sit here for Offline mode. It now lives in the
            // details drawer's Attendance tab instead — see showAttendanceActionOnCard
            // above, which holds the condition this branch used to test.
            showAttendanceActionOnCard ? (
              <div
                onClick={(e) => {
                  if (isClassOver) return;
                  e.stopPropagation();
                  markAttendanceHandler();
                }}
                style={{
                  cursor: isClassOver ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  opacity: isClassOver ? 0.5 : 1
                }}
                title={isClassOver ? 'Class has ended' : ''}
              >
                <img src={avattar} alt="att" style={{ width: 20, height: 20 }} />
                <span style={{ fontWeight: 600, color: "#594099", fontSize: 14, whiteSpace: 'nowrap' }}>
                  {onGoingItem?.attendanceMarked ? "EDIT ATTENDANCE" : "MARK ATTENDANCE"}
                </span>
              </div>
            ) : null
          )}
        </div>
      </div>



      {/* <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}> */}
      {/* <div className="ongoingclass-img-text"> */}
      {/* <div>
                        <SquareSubIcon icon={onGoingItem?.subject?.icon ? onGoingItem?.subject?.icon : ''} name={onGoingItem?.subject?.name ? onGoingItem?.subject?.name : ''} size={40} />
                    </div> */}
      {/* <div style={{ width: '100%', marginLeft: '10px', display: 'flex', flexDirection: 'column' }}> */}
      {/* <Text
              className="truncate-2-lines"
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#1F1F1F",
                marginBottom: 6,
              }}
            >
  {onGoingItem?.subject?.name}
</Text> */}
      {/* <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: 16,
    fontSize: 13,
    color: "#636363",
    marginBottom: 10,
  }}
>
  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
    <img
      src={require("../../Assets/schedule/teacher.svg").default}
      style={{ width: 14 }}
    />
    <span>{onGoingItem?.teacher?.name}</span>
  </div>

  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
    <img
      src={require("../../Assets/schedule/timer.svg").default}
      style={{ width: 14 }}
    />
    <span>{Math.round(duration.asMinutes())} mins</span>
  </div>
</div> */}
      {/* <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 6,
  }}
>
  <Text style={{ fontSize: 12, color: "#636363" }}>
    {onGoingItem?.batchName || "Pulse NEET 2025"} + 1 more
  </Text>

  <Button
    type="link"
    style={{
      fontWeight: 600,
      color: "#594099",
      paddingRight: 0,
    }}
    onClick={handleJoin}
  >
    JOIN NOW
  </Button>
</div> */}



      {/* {onGoingItem.mode == "Zoom 40" ?
                            <div style={{ width: '74px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E7F3FF', borderRadius: '8px', padding: '2px' }}>
                                <IoMdVideocam style={{ color: '#1089FF' }} />
                                <Text style={{ fontSize: '10px', color: '#1089FF', marginLeft: '5px' }}>Zoom 40</Text>
                            </div>
                            : onGoingItem.mode == "Broadcast" ?
                                <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E9FFF9', border: '1px solid #C8EEE4', borderRadius: '8px', padding: '3px 7px'}}>
                                    <img src={Online}  style={{ color: '#00A566', textAlign: 'center',height:"16px",width:"16px" }} />
                                    <Text style={{ fontSize: '10px', color: '#00A566', marginLeft: '5px' }}>Online</Text>
                                </div>
                                :
                                onGoingItem.mode == "Conference" ?
                                    <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F6F4FE', borderRadius: '8px', padding: '3px 7px' }}>
                                        <img src={Conference} style={{ color: '#594099',height:"16px",width:"16px" }} />
                                        <Text style={{ color: '#594099', marginLeft: '5px', fontSize: '10px' }}>Conference</Text>
                                    </div>
                                    :
                                    onGoingItem.mode == 'Others' ?
                                    <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFE5F4', borderRadius: '8px', padding: '3px 7px' }}>
                                        <img src={OtherColor} style={{ color: '#E50087',height:"16px",width:"16px" }} />
                                        <Text style={{ color: '#E50087', marginLeft: '5px', fontSize: '10px' }}>Other</Text>
                                    </div>
                                    :
                                    <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFD8DA', border: '1px solid #FFF5F6', borderRadius: '8px', padding: '3px 7px' }}>
                                        <img src={Offline} style={{ color: '#FF414D', textAlign: 'center',height:"16px",width:"16px" }} />
                                        <Text style={{ fontSize: '10px', color: '#FF414D', marginLeft: '5px' }}>Offline</Text>
                                    </div>
                        } */}
      {/* <div style={{ width: 240, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ width: 120 }}>
                                <Typography.Text ellipsis={{ tooltip: true }} style={{ fontWeight: 600, fontSize: 14, fontFamily: 'roboto', width: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>{onGoingItem?.subject?.name}</Typography.Text>
                            </div>
                            <div style={{ flexShrink: 0 }}>
                                {((user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('Admin') || user?.privilage?.includes('Planner'))) ?
                                    onGoingItem?.mode == 'Others'?
                                        null
                                        // <div className='r-c-c'>
                                        //     <Tooltip placement="left" title="Embed Link">
                                        //         <div style={{cursor:"pointer"}} onClick={()=>{handleJoin()}}>
                                        //             <LinkOutlined style={{color:'#594099', fontSize:20}}/>
                                        //         </div>
                                        //     </Tooltip>
                                        //     {onGoingItem?.sUrl != undefined ?
                                        //     <div className={'r-c-c cursor-pointer'} onClick={onPlay}>
                                        //         <img style={{ height: 20, width: 20, opacity: 1, marginLeft:10 }} src={require('../broadcast/localComponent/assets/Group 10666.svg').default} alt="" />
                                        //     </div> 
                                        //     :
                                        //     null}
                                        // </div>
                                    :
                                    <Button type='primary' style={{ width: '100px', borderRadius: '8px' }} onClick={() => handleJoin()} disabled={isJoinLoader} loading={isJoinNowLoading}>{'Join Now' } </Button>
                                    : null}
                            </div>
                        </div> */}
      {/* <div style={{ width: '100%', display: "flex", flexDirection: "row", alignItems: "center", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
                                                            <FaGraduationCap style={{ color: 'purple', marginRight: '5px' }} />
                                                        {onGoingItem?.standards.length != 0 ? onGoingItem?.standards?.map((item, index, array) => (
                                <Tooltip title={onGoingItem?.standards.length != 0 ? onGoingItem?.standards?.map((item, index, array) => (`${item?.std + "-" + item?.section}${index === array.length - 1 ? '' : ' | '}`)) : null}>
                                    <Text style={{ fontSize: '80%', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '40%' }} key={index}>{item?.std}-{item?.section}{index === array.length - 1 ? '' : '|'}</Text>
</Tooltip>
                            )) : null}
                        </div> */}
      {/* </div> */}
      {/* {((user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('Admin') || user?.privilage?.includes('Planner'))) ?
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100px', marginLeft: 50 }}>
                            {onGoingItem.mode === "Offline" ?
                                null :
                                <Button type='primary' style={{ width: '100px', borderRadius: '16px', marginLeft: '4px' }}
                                    onClick={() => handleJoin()}
                                    disabled={isJoinLoader}
                                >{isJoinNowLoading ? <LoadingOutlined /> : null} Join Now</Button>}
                        </div> : null} */}
      {/* </div> */}
      {/* </div> */}
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
        {/* <div className='r-c-c'>
                    <UserAvatar size="small" shape="circle" name={onGoingItem?.teacher?.name} img={onGoingItem?.teacher?.image == "default.png" ? "" : `${Api._s3_url}${onGoingItem?.teacher?.image}`} />
                    <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{onGoingItem?.teacher?.name}</Text>
                </div> */}
        {/* {((user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('AttendanceMarker')) && (onGoingItem?.mode === 'Offline')) ?
                    <div style={{ marginLeft: '15px', cursor: 'pointer' }} onClick={markAttendanceHandler}>
                        <Avatar shape='circle' size='small' src={avattar} />
                        <Text style={{ marginLeft: '5px', color: onGoingItem?.attendanceMarked ? '#636363' : '#1089FF', fontSize: '10px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 'bold', cursor: 'pointer' }} disabled={onGoingItem?.attendanceMarked ? ((user?.privilage?.includes('SuperAdmin')) || (user?.privilage?.includes('Admin')) || (user?.privilage?.includes('Planner')) ? false : true) : false}>{onGoingItem?.attendanceMarked ? `${onGoingItem?.attendanceData?.presentCount}/${onGoingItem?.attendanceData?.studentCount}` : 'MARK ATTENDANCE'}</Text>
                    </div>
                    :
                    null
                } */}
        {/* <div style={{ marginLeft: "90px" }}>
                    <Avatar
                        style={{ backgroundColor: '#594099' }}
                        size={14}
                        icon={<UserOutlined />}
                    />
                    <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{onlineData[onGoingItem.roomName].length} Online</Text>
                </div> */}
      </div>
      {/* <div>
                <Progress percent={parseInt(((spendHours) / hours) * 100)} showInfo={false} strokeColor="#594099" />
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Text style={{ color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{`${moment(onGoingItem?.startTime, "HH:mm:ss").format('hh:mm A')}`}</Text>
                    <Text style={{ color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{`${moment(onGoingItem?.endTime, "HH:mm:ss").format('hh:mm A')}`}</Text>
                </div>

            </div> */}
      {/* {((user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('AttendanceMarker')) && (onGoingItem?.mode === 'Offline')) ?
                <div style={{ margin: '5px auto', padding: '5px 0' }}>
                    {onGoingItem?.attendanceMarked
                        ?
                        <Button style={{ width: '280px', borderRadius: '50px', backgroundColor: '#E6E6E6', color: '#AEAEAE', fontSize: '14px', height: '35px' }} onClick={markAttendanceHandler} disabled><img src={checkCirlce} style={{ paddingRight: '6px' }}></img><span>ATTENDANCE MARKED</span></Button>
                        :
                        <Button style={{ width: '280px', borderRadius: '50px', backgroundColor: '#594099', color: '#FFFFFF', fontSize: '14px', height: '35px' }} onClick={markAttendanceHandler} >MARK ATTENDANCE</Button>
                    }

                </div>
                : null} */}



      {embedModalVisible ? <EmbedModal adding={onGoingItem.sUrl == undefined} embedding={embedding} visible={embedModalVisible} onClose={() => { setEmbedModalVisible(false) }} onOk={onEmbed} /> : null}

      <div
        style={{
          marginTop: 0,
          paddingTop: 4,
          marginLeft: -22,
          marginRight: -22,
          marginBottom: -22,
        }}
      >
        <Progress
          percent={Math.min(100, Math.max(0, parseInt((spendHours / hours) * 100)))}
          showInfo={false}
          strokeColor="#594099"
          trailColor="#EDEDED"
          strokeWidth={8}
          strokeLinecap="round"
          style={{ margin: 0 }}
        />
      </div>

      <ScheduleDetailsDrawer
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        schedule={onGoingItem}
        togglePageLoader={togglePageLoader}
        pageLoader={pageLoader}
        isOngoingClass
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  const {
    scheduleId,
    access,
    delOrCancel,
    isJoinLoader,
    presentStudents,
    studentAttendanceData,
    currentDate
  } = state.schedule;
  const { user } = state.session
  return {
    scheduleId,
    access,
    delOrCancel,
    user,
    isJoinLoader,
    presentStudents,
    studentAttendanceData,
    currentDate
  };
};

const mapDispatchToProps = (dispatch) => ({
  setStreamId: (streamId) => dispatch(setStreamId(streamId)),
  joinClass: (id, callBack) => dispatch(joinClass(id, callBack)),
  setBroadcastSelectedClassroom: (newClass) => dispatch(setBroadcastSelectedClassroom(newClass)),
  setJoinLoader: (bool) => dispatch(setJoinLoader(bool)),
  fetchStudentListData: (id) => dispatch(fetchStudentListData(id)),
  setSelectedId: (id) => dispatch(setSelectedId(id)),
  setCardData: (value) => dispatch(setCardData(value)),
  postEmbedLink: (params, c, sc) => dispatch(postEmbedLink(params, c, sc)),
  setLiveStreamUrl: (url) => dispatch(setLiveStreamUrl(url))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps

)(OngoingClassCard);
